import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Marterial from "./marterial";
import MasterdataServices from "./masterdataServices";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MasterData() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_mains">
                <h5>Master Data</h5>
              </div>
            </div>
            <Box>
              <Box className="master_data_row_tabs">
                <Tabs className="master_data_tabs_basic" value={value} onChange={handleChange}>
                  <Tab label="Material" {...a11yProps(0)} />
                  <Tab label="Service" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <Marterial />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <MasterdataServices />
              </CustomTabPanel>
            </Box>
          </div>
        </div>
      </div>
    </>
  )
}

export default MasterData